import React from "react";

function Social() {
  return (
    <div className="home__social">
      <a
        href="https://github.com/haseeeb1"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-github-alt"></i>
      </a>
      <a
        href="https://linkedin.com/in/haseeb-ul-hassan"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-linkedin"></i>
      </a>
      <a
        href="https://instagram.com/haseeeb_ul_hassan"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-instagram"></i>
      </a>
    </div>
  );
}

export default Social;
